//The contents of this file have been generated automatically. Do not edit this file.

import { z } from 'zod';
import {
    AutotraderTraceParentZod,
    AutotraderTraceStateZod,
    AutotraderRunDataZod,
    AutotraderRunZod,
} from './schemas';

export const ParamsTypeZOD = z.object({
    automationId: z.string(),
    requestBody: AutotraderRunDataZod,
});
export type ParamsType = z.TypeOf<typeof ParamsTypeZOD>;

const checkResponse = <A>(code: number, decoder: z.ZodType<A>, data: unknown): A => {
    const decodeResult = decoder.safeParse(data);
    if (decodeResult.success) {
        return decodeResult.data;
    }
    console.error('error details', {
        errors: decodeResult.error.errors,
        data
    });
    throw Error(`Response decoding error /autotrader/v1/automations/{automationId}/runs -> post -> ${code}`);
};


export const Response201ZOD = z.object({
    data: AutotraderRunZod,
});
export type Response201Type = z.TypeOf<typeof Response201ZOD>;

export const Response400ZOD = z.object({
    error: z.object({
        code: z.union([z.literal('already-exists'), z.literal('validation-error')]),
        message: z.string(),
    }),
});
export type Response400Type = z.TypeOf<typeof Response400ZOD>;

export const Response401ZOD = z.object({
    error: z.object({
        code: z.literal('unauthorized'),
        message: z.string(),
    }),
});
export type Response401Type = z.TypeOf<typeof Response401ZOD>;

export const Response403ZOD = z.object({
    error: z.object({
        code: z.literal('forbidden'),
        message: z.string(),
    }),
});
export type Response403Type = z.TypeOf<typeof Response403ZOD>;

export const Response500ZOD = z.object({
    error: z.object({
        code: z.literal('internal-server-error'),
        message: z.string(),
    }),
});
export type Response500Type = z.TypeOf<typeof Response500ZOD>;


const ExtraHeadersZod = z.object({
    traceparent: AutotraderTraceParentZod.optional(),
    tracestate: AutotraderTraceStateZod.optional(),
    authorization: z.string().optional(),
});
type ExtraHeadersType = z.TypeOf<typeof ExtraHeadersZod>;


export type ApiCreateRunParamsType = ParamsType;


export type ApiCreateRunResponseType = 
    {
        status: 201;
        body: Response201Type;
    } | 
    {
        status: 400;
        body: Response400Type;
    } | 
    {
        status: 401;
        body: Response401Type;
    } | 
    {
        status: 403;
        body: Response403Type;
    } | 
    {
        status: 500;
        body: Response500Type;
    };

const convertHeaders = (params: Record<string, string | null | undefined>): Record<string, string> => {
    const result: Record<string, string> = {};

    for (const [name, value] of Object.entries(params)) {
        if (value !== null && value !== undefined) {
            result[name] = value;
        }
    }

    return result;
};

export const apiCreateRunRequest = async (
    api_url: string,
    params: ParamsType,
    extraHeaders: ExtraHeadersType
): Promise<ApiCreateRunResponseType> => {
    const ok = ParamsTypeZOD.safeParse(params);
    if (!ok.success) {
        console.error('Input parameters do not match the definition from openapi');
    }

    
        
    const query = '';
    const url = `${api_url}/autotrader/v1/automations/${params.automationId}/runs${query}`;
    

    const headers = convertHeaders({
        'Content-Type': 'application/json; charset=utf-8',
        ...extraHeaders
    });

    const response = await fetch(url, {
        method: 'POST',
        headers,
        body: JSON.stringify(params.requestBody),
        credentials: 'include'
    });

    const status = response.status;

    let json = null;

    try {
        const text = await response.text();
        if (text !== '') {
            json = JSON.parse(text);
        }
    } catch (_err) {
        throw Error(`Http status ${status} - json was expected`);
    }
    
    if (status === 201) {
        return { status: 201, body: checkResponse(201, Response201ZOD, json) };
    }

    if (status === 400) {
        return { status: 400, body: checkResponse(400, Response400ZOD, json) };
    }

    if (status === 401) {
        return { status: 401, body: checkResponse(401, Response401ZOD, json) };
    }

    if (status === 403) {
        return { status: 403, body: checkResponse(403, Response403ZOD, json) };
    }

    if (status === 500) {
        return { status: 500, body: checkResponse(500, Response500ZOD, json) };
    }

    throw new Error(`apiCreateRunRequest - unhandled response ${status}`);
};
